export const mandatoryPhone = {
  'Hello, friend!': '¡Hola!',
  'We could not find your cellphone number through your social login':
    'Lamentablemente no pudimos encontrar tu número de celular a través de tu inicio de sesión',
  'Please fill in the field below to continue browsing':
    'Por favor, completá el campo de abajo para continuar navegando',
  'Log out and identify yourself again': 'Salir e identificarse nuevamente',
  'Almost there!': '¡Ya casi!',
  'We need your cellphone number to complete your sign-up':
    'Para completar tu registro, necesitamos que nos indiques tu celular',
  PHONE_PLACEHOLDER: 'XXXX XXXXX',
};
